module.exports = __webpack_public_path__ + "img/class.c5e900ef.svg";